import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, ArrowRight } from "lucide-react";
import { api, mediaUrl } from "@/lib/api";
import { useSettings } from "@/context/SettingsContext";
import { PageHeader, Spinner } from "@/components/site/Bits";
import { InquiryForm } from "@/components/site/InquiryForm";

export const ComingSoon = () => {
  const [items, setItems] = useState<any[] | null>(null);
  const [open, setOpen] = useState<string>("");
  useEffect(() => {
    api.get("/coming-soon").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);
  return (
    <div>
      <PageHeader eyebrow="On the horizon" title="Coming Soon" intro="These offerings are not available yet. We list them here so you can register interest — nothing on this page can be booked today." />
      <div className="container-x space-y-6 py-14">
        {!items ? <Spinner /> : items.map((it) => (
          <div key={it.id} className="card-lux overflow-hidden" data-testid={`coming-soon-${it.id}`}>
            <div className="grid gap-6 p-6 sm:p-8 md:grid-cols-[1fr_auto] md:items-center">
              <div className="flex gap-5">
                {it.image && <img src={mediaUrl(it.image)} alt="" className="hidden h-24 w-32 rounded-xl object-cover sm:block" />}
                <div>
                  <span className="font-mono text-[10px] uppercase tracking-widest text-gold">{it.category}</span>
                  <h2 className="mt-1 text-2xl">{it.title}</h2>
                  <p className="mt-2 max-w-2xl text-sm text-navy/65">{it.description}</p>
                </div>
              </div>
              {it.title === "Gant Estate" ? <Link to="/estates" className="btn-ghost" data-testid="coming-soon-gant-link">Learn more <ArrowRight size={14} /></Link>
                : it.inquiry_enabled && <button onClick={() => setOpen(open === it.id ? "" : it.id)} className="btn-ghost" data-testid={`coming-soon-notify-${it.id}`}>Register interest</button>}
            </div>
            {open === it.id && <div className="border-t border-navy/10 bg-stone-canvas p-6"><InquiryForm kind="coming_soon" subjectId={it.id} subjectTitle={it.title} cta="Notify me" testid={`cs-inquiry`} /></div>}
          </div>
        ))}
      </div>
    </div>
  );
};

export const GantEstate = () => {
  const { s } = useSettings();
  return (
    <div>
      <PageHeader eyebrow="Future project · Coming soon" title="Gant Estate" intro={s?.gant_estate?.intro} testid="gant-title" />
      <div className="container-x grid gap-10 py-14 lg:grid-cols-[1fr_480px]">
        <div className="flex gap-4 rounded-2xl border border-amber-300 bg-amber-50 p-6 text-sm text-amber-900 lg:self-start" data-testid="gant-disclaimer">
          <AlertTriangle className="shrink-0" size={20} />
          <div><p className="font-semibold">Important disclaimer</p><p className="mt-2 leading-relaxed">{s?.gant_estate?.disclaimer}</p></div>
        </div>
        <div>
          <h2 className="mb-4 text-2xl">Register your interest</h2>
          <InquiryForm kind="gant_estate" subjectTitle="Gant Estate" cta="Register interest" testid="gant-inquiry" />
        </div>
      </div>
    </div>
  );
};
